<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card class="v-em">
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>{{ readonly ? "查看员工信息":"填写员工信息"}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container>
        <v-layout v-if="!readonly" justify-end>
          <v-btn :href="templateUrl" color="primary" flat>下载模板</v-btn>
          <CUpload
            :show="false"
            :on-success="onUploadSuccess"
            :on-error="onUploadError"
            :limit="1"
            action="/app/api/upload/groupEmployeeInfo"
            accept=".xlsx, .xls"
          >批量上传</CUpload>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-form ref="form" lazy-validation>
              <v-data-table :headers="headers" :items="items" hide-actions class="employee-table">
                <template slot="items" slot-scope="props">
                  <tr v-if="props.item._isEdit">
                    <td>
                      <v-text-field v-model="props.item.name" :rules="rules.name"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="props.item.idCard" :rules="rules.idCard"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="props.item.phone" :rules="rules.phone"></v-text-field>
                    </td>
                    <td>
                      <JobCategory v-model="props.item.category" :rules="rules.category" :limit="5"></JobCategory>
                    </td>
                    <td>
                      <v-btn
                        v-if="props.index===0"
                        color="primary"
                        outline
                        @click.native="onCreate(props.index)"
                      >添加</v-btn>
                      <v-btn v-else color="primary" outline @click.native="onSave(props.index)">保存</v-btn>
                    </td>
                  </tr>
                  <tr v-else>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.idCard }}</td>
                    <td>{{ props.item.phone }}</td>
                    <td>{{ props.item.category.name }}</td>
                    <td v-if="!readonly" class="text-xs-center">
                      <!-- todo:后续再做编辑 -->
                      <!-- <v-btn flat class="operation-btn" @click="onEdit(props.index)">编辑</v-btn> -->
                      <v-btn flat class="operation-btn" @click="onDelete(props.index)">删除</v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4">
          <v-flex>
            <strong>
              员工总数：
              <em class="em">{{ employees.length }}</em> 人
            </strong>
            <span>（1-3类职业 {{ oc3Count }} 人，4类职业 {{ oc4Count }} 人，5类职业 {{ oc5Count }} 人）</span>
          </v-flex>
          <v-flex shrink>
            <v-btn v-if="!readonly" color="primary" @click="confirm" block>确定</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import JobCategory from "@/components/Order/JobCategory";
import validate from "@/assets/js/validate";
import dateUtil from "@/assets/js/utils/date";
export default {
  components: {
    JobCategory
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templateUrl:
        "https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E8%AF%9A%E6%B3%B0%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E9%99%A9%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx",
      headers: [
        {
          text: "姓名",
          value: "name",
          sortable: false
        },
        {
          text: "身份证号",
          value: "idCard",
          sortable: false
        },
        {
          text: "手机号",
          value: "phone",
          sortable: false
        },
        {
          text: "职业类别",
          value: "category",
          sortable: false
        },
        {
          text: "操作",
          sortable: false,
          align: "center"
        }
      ],
      items: [],
      editObjTemplate: {
        _isEdit: true,
        _status: 0, // 0 还未添加，1：已添加未保存，2：已保存
        name: "",
        idCard: "",
        phone: "",
        category: {
          code: "",
          name: "",
          level: 0
        }
      },
      rules: {
        name: [
          v => {
            if (!v) {
              return "请输入姓名";
            }
            if (!validate.isChineseName(v)) {
              return "姓名格式错误，请重新输入";
            }
            return true;
          }
        ],
        idCard: [
          v => {
            if (!v) {
              return "请输入身份证号";
            }
            if (!validate.isIDCard(v)) {
              return "请输入正确的身份证号";
            }
            if (
              this.items.findIndex(item => !item._isEdit && item.idCard === v) >
              -1
            ) {
              return "身份证号重复，请重新输入";
            }
            const birthday = dateUtil.getBirthdayByID(v);
            const age = dateUtil.getAge(birthday);
            if (age < 16 || age > 65) {
              return "年龄未在承保范围（16周岁 - 65周岁）";
            }
            return true;
          }
        ],
        phone: [
          v => {
            if (!v) {
              return "请输入手机号";
            }
            if (!validate.isMobilePhone(v)) {
              return "手机号格式错误，请重新输入";
            }
            return true;
          }
        ],
        category: [
          v => {
            if (!v) {
              return "请选择职业类别";
            }
            const codes = this.items.map(item => item.category.code);
            const count = Array.from(new Set(codes)).length;
            if (count > 17) {
              return "单次投保中最多支持17种不同的职业，如超过请分开投保";
            }
            return true;
          }
        ]
      }
    };
  },
  computed: {
    dialog: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      }
    },
    employees() {
      return this.items.filter(item => item._status !== 0);
    },
    oc3Count() {
      return this.employees.filter(item => item.category.level <= 3).length;
    },
    oc4Count() {
      return this.employees.filter(item => item.category.level === 4).length;
    },
    oc5Count() {
      return this.employees.filter(item => item.category.level === 5).length;
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.items = this.value.map(item => item);
        if (!this.readonly) {
          this.addEditItem();
        }
      }
    }
  },
  created() {
    if (this.readonly) {
      this.headers.pop();
    }
  },
  methods: {
    addEditItem() {
      const editItem = Object.assign({}, this.editObjTemplate);
      this.items.unshift(editItem);
    },
    categorySelected(index, selected) {
      this.items[index].categoryCode = selected.code;
      this.items[index].categoryLevel = selected.level;
      this.items[index].category = selected.name;
    },
    onCreate(index) {
      if (this.$refs.form.validate()) {
        let item = this.items[index];
        item._isEdit = false;
        item._status = 1;
        // 永远保持一个编辑的行在第一行
        this.addEditItem();
        this.$refs.form.resetValidation();
      }
    },
    onEdit(index) {
      let newItem = this.items[index];
      newItem._isEdit = true;
      this.items.splice(index, 1, newItem);
    },
    onSave(index) {
      if (this.$refs.form.validate()) {
        let item = this.items[index];
        item._isEdit = false;
        item._status = 1;
        // 永远保持一个编辑的行在第一行
        this.addEditItem();
        this.$refs.form.resetValidation();
      }
    },
    onDelete(index) {
      this.items.splice(index, 1);
    },
    onUploadSuccess(res) {
      res.data.data.forEach(element => {
        this.items.push({
          _isEdit: false,
          _status: 1, // 0 还未添加，1：已添加未保存，2：已保存
          name: element.name,
          idCard: element.idNumber,
          phone: element.phoneNo,
          category: {
            code: element.professionCode,
            name: element.professionName,
            level: element.professionLevel
          }
        });
      });
    },
    onUploadError(err) {
      // this.$message.error(err.message);
      let error = err.message.replace(/;/g, "<br>");
      const message =
        "您导入的员工信息中有格式错误，请修改后重新上传，具体错误信息如下所示：<br>" +
        error;
      this.$messageBox.alert({
        message,
        width: 500
      });
    },
    confirm() {
      if (this.employees.length < 5) {
        this.$message.error("员工人数需达5人，请继续补充人数");
        return false;
      }
      if (this.oc4Count / this.employees.length > 0.8) {
        this.$message.error("4类职业人员在总人数中占比不能超过80%");
        return false;
      }
      if (this.oc5Count / this.employees.length > 0.5) {
        this.$message.error("5类职业人员在总人数中占比不能超过50%");
        return false;
      }
      if (this.oc3Count === 0) {
        this.$message.error("4-5类职业不能单独承保");
        return false;
      }
      this.dialog = false;
      this.$emit("input", this.employees);
    }
  }
};
</script>

<style lang="scss">
.v-em {
  .operation-btn {
    min-width: auto;
    margin: 6px 0;
  }
  .employee-table {
    .v-table__overflow {
      max-height: 700px;
      overflow: auto;
    }
  }
}
</style>

